module.exports = __webpack_public_path__ + "media/assets/systems-map-icons/operations/SAP-79a743a08cb14b1d9ece42dd0ad493c23f0000c5ba3d29b1f691f6b16ec4a92b.png";